
const sayError = (e) => {
  console.log('err',e)
  window.alert(typeof e.response.data === "string" ? e.message:  e.response.data.message[0] )

};


export default sayError;